import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Button, Modal, Card, Spinner } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../Helpers/fetcher.js";
import { Notify } from "../../Helpers/notification.js";
import ReactTooltip from 'react-tooltip';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Cookies from 'js-cookie';

import "./index.css";
import { FORTY_FIVE_SECONDS } from '../../Helpers/constant.js';
class DialerManagement extends Component {
	constructor(props) {

		super(props);
		this.state = {
			dialerList: [],
			selectedDialerId: 0,
			showAddCreditModal: false,
			sizePerPage: 10,
			isLoading:true
		}
		this.intervalId = null;
	}
	componentDidMount() {
		this.getDialer();
		const savedSizePerPage = Cookies.get('dialerListsizePerPage');
		if (savedSizePerPage) {
			this.setState({ sizePerPage: Number(savedSizePerPage) });
		}

		//45 sec
		this.intervalId = setInterval(() => {
            this.getDialer({ preserveModals: true });
        }, FORTY_FIVE_SECONDS );
	}

	componentWillUnmount() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

	getDialer = (options = {}) => {
		const { preserveModals = false } = options;
		const apiPath = this.props.app.apiPath;

		Fetcher.get(apiPath + '/api/obd/dialers/list')
			.then(res => {
				const newState = { dialerList: res };
                
                if (!preserveModals) {
                    newState.showAddCreditModal = false;
                }
                
                this.setState(newState);
			})
			.catch(err => { console.log('Error in fetching Dialer List', err) })
			.finally(()=>this.setState({isLoading:false}));
	}


	setvalue = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	}

	setMessageShow = (status) => {
		this.setState({
			showAddCreditModal: false,
		});
	}

	showAddCreditModal = (userId) => {
		this.setState({
			showAddCreditModal: true,
			selectedDialerId: userId
		});
	}

	handleSizePerPageChange = (newSizePerPage) => {
		this.setState({ sizePerPage: newSizePerPage });
		Cookies.set('dialerListsizePerPage', newSizePerPage);
	}

	render() {

		const dialerList = this.state.dialerList;
		var columns;
		
			columns = [
				{
					dataField: 'dialerId',
					text: 'Dialer Id',
					sort: true,
					hidden: false
				},
				{
					dataField: 'dialerName',
					text: 'Dialer Name',
					sort: true,
					searchable: true
				},
				{
					dataField: 'dialerIP',
					text: 'IP',
					sort: true,
					searchable: true
				},
				{
					dataField: 'dialerPort',
					text: 'Port',
					sort: true,
					searchable: true
				},
				{
					dataField: 'pilotNumber',
					text: 'Pilot No.',
					sort: true,
					searchable: true
				},
				{
					dataField: 'activeCli',
					text: 'Active CLI',
					sort: true,
					searchable: true
				},
				{
					dataField: 'dialerCalls',
					text: 'Active Calls',
					sort: true,
					searchable: true
				},
				{
					dataField: 'totalChannels',
					text: 'Total Channels',
					sort: true,
					searchable: true
				},
				{
					dataField: 'channelReduction',
					text: 'Channel Reduction',
					sort: true,
					searchable: true
				},
				{
					dataField: 'cpsReduction',
					text: 'CPS Reduction',
					sort: true,
					searchable: true
				},
				{
					dataField: 'action',
					text: 'Action',
					sort: false,
					searchable: false
				},];
		
		const dialer = Array.isArray(dialerList) ? dialerList.map((dialers, index) => {
				let action = [ <Link data-tip="Edit Dialer" key={`${index}-edit-dialer`} className="edit-dialer" to={`${this.props.app.urlPrefix}/update-dialer/${dialers.dialerId}`}><i className="fa fa-edit"></i></Link> ];
				return {
					dialerId: dialers.dialerId,
					dialerName: dialers.dialerName,
					dialerIP: dialers.dialerIP,
					dialerPort: dialers.dialerPort,
					activeCli: dialers.activeCli,
					totalChannels : dialers.totalChannels,
					dialerCalls: dialers.dialerCalls,
					channelReduction: dialers.channelReduction,
					cpsReduction: dialers.cpsReduction,
					action: action,
					pilotNumber: dialers.pilotNumber
				};
		}) : []
		const { SearchBar, ClearSearchButton } = Search;

		const defaultSorted = [{
			dataField: 'dialerId',
			order: 'desc'
		}];

		const paginationOption = {
			custom: true,
			totalSize: dialer.length,
			sizePerPage: this.state.sizePerPage,
			sizePerPageList: [10, 25, 50, 100],
			onSizePerPageChange: this.handleSizePerPageChange
		};

		return (
			<Card>
				{/*<Card.Header>Users List<span>&nbsp;&nbsp;&nbsp;</span><span className="float-none avail-credit-cont"><span className="credits-avail">Available Credits: {this.state.adminCredits}</span></span></Card.Header>*/}
				<Card.Header>Dialer List</Card.Header>
				<Card.Body>
					<div className="widget-list-table-cont">
						{/* <h3>Campaign Summary</h3> */}
						{/*{!isEmpty( this.state.dialerList ) && <PaginationProvider pagination={paginationFactory( paginationOption )}>*/}
						{this.state.isLoading ? (<div className="loader">
							<Spinner animation="border" variant="primary" />
						</div>) : <PaginationProvider pagination={paginationFactory(paginationOption)}>
							{
								({
									paginationProps,
									paginationTableProps
								}) => (
									<ToolkitProvider
										keyField="cliId"
										data={dialer}
										columns={columns}
										search
										bootstrap4

									>
										{
											props => (
												<div className="">
													Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
													<span className="search-cont"><SearchBar  {...props.searchProps} /></span>
													<ClearSearchButton className="btn-primary btn-round" {...props.searchProps} />
													{/*<span>&nbsp;&nbsp;&nbsp;</span><span className="float-none avail-credit-cont"><span className="credits-avail">Available Credits: {this.state.adminCredits}</span></span>*/}
													{/*<Link className="float-right btn btn-default btn-primary" to={`${this.props.app.urlPrefix}/add-cli`}>Allocate CLI</Link>*/}

													<BootstrapTable defaultSorted={defaultSorted} bordered={true} hover condensed wrapperClasses="table-responsive" classes="mt-3  widgetlist-table"  {...props.baseProps}  {...paginationTableProps} noDataIndication={() => (<div>{'No data available'}</div>)} />
													<PaginationListStandalone {...paginationProps} />
													<ReactTooltip />
												</div>
											)
										}
									</ToolkitProvider>
								)
							}
						</PaginationProvider>}
					</div>

					

				</Card.Body>
			</Card>

		);
	}
}

export default DialerManagement;